<div class="row">
  <div class="payment-container">
    <div class="mw xl-12 md-12 sm-12 xs-12">
      <div class="payment-text mobile-hide">
        <h2>
          {{ 'static.footerPayments' | translate }}
        </h2>
      </div>
      <div class="payment-text mobile-show">
        <h2>
          {{ 'static.footerPaymentsM' | translate }}
        </h2>
      </div>
      <div *ngIf="brand === 'qiwi'" class="image-container jinnilotto LANG{{this.subscriptionsService.countryCodeValue}}">
        <div *ngIf="this.subscriptionsService.countryCodeValue !== 'de'" class="image visa"><img [src]="'/assets/images/payments/visa.png'" [srcset]="'/assets/images/payments/VISA@2x.png 2x'"></div>
        <div class="image mastercard"><img [src]="'/assets/images/payments/mastercard.png'" [srcset]="'/assets/images/payments/mastercard@2x.png 2x'"></div>
        <div class="image maestro"><img [src]="'/assets/images/payments/maestro.png'" [srcset]="'/assets/images/payments/maestro@2x.png 2x'"></div>
        <div class="image ecopayz"><img [src]="'/assets/images/payments/our-04.svg'"></div>
        <div class="image ecopayz"><img [src]="'/assets/images/payments/ecopayz-footer.png'" [srcset]="'/assets/images/payments/ecopayz-footer@2x.png 2x'"></div>
        <div class="image interac"><img [src]="'/assets/images/payments/Interac.svg'"></div>
        <div class="image etransfer"><img [src]="'/assets/images/payments/svg/etransfer.svg'"></div>
        <div class="image neteller"><img [src]="'/assets/images/payments/ic_neteller.svg'"></div>
        <div class="image interac"><img [src]="'/assets/images/payments/skrillnoborder.svg'"></div>
      </div>
        <div *ngIf="brand === 'winaija'" class="image-container winaija mobileOnly">
            <div class="image visa"><img [src]="'/assets/images/payments/visa.png'" [srcset]="'/assets/images/payments/VISA@2x.png 2x'"></div>
            <div class="image mastercard"><img [src]="'/assets/images/payments/mastercard.png'" [srcset]="'/assets/images/payments/mastercard@2x.png 2x'"></div>
            <div class="image paystack"><img [src]="'/assets/images/payments/paystack.png'" [srcset]="'/assets/images/payments/paystack@2x.png 2x'"></div>
        </div>
        <div *ngIf="brand === 'winaija'" class="image-container winaija fourElements mobileOnly">
            <div class="image 737 oneElementOfFour"><img [src]="'/assets/images/payments/737.png'" [srcset]="'/assets/images/payments/737@2x.png 2x'"></div>
            <div class="image bank oneElementOfFour"><img [src]="'/assets/images/payments/bank.svg'"></div>
            <div class="image ussd oneElementOfFour"><img [src]="'/assets/images/payments/ussd.svg'"></div>
            <div class="image visa-qr oneElementOfFour"><img [src]="'/assets/images/payments/visa-qr.svg'"></div>
        </div>
        <div *ngIf="brand === 'winaija'" class="image-container winaija fourElements desktopOnly">
            <div class="image visa"><img [src]="'/assets/images/payments/visa.png'" [srcset]="'/assets/images/payments/VISA@2x.png 2x'"></div>
            <div class="image mastercard"><img [src]="'/assets/images/payments/mastercard.png'" [srcset]="'/assets/images/payments/mastercard@2x.png 2x'"></div>
            <div class="image paystack"><img [src]="'/assets/images/payments/paystack.png'" [srcset]="'/assets/images/payments/paystack@2x.png 2x'"></div>
        <div class="image 737 oneElementOfFour"><img [src]="'/assets/images/payments/737.png'" [srcset]="'/assets/images/payments/737@2x.png 2x'"></div>
        <div class="image bank oneElementOfFour"><img [src]="'/assets/images/payments/bank.svg'"></div>
        <div class="image ussd oneElementOfFour"><img [src]="'/assets/images/payments/ussd.svg'"></div>
        <div class="image visa-qr oneElementOfFour"><img [src]="'/assets/images/payments/visa-qr.svg'"></div>
      </div>
    </div>
  </div>
</div>
